import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { extract } from '../../../util/util';
import { toast } from 'react-toastify';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import { FinField, FinTextarea } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';

export default function CadastroEventoParticipanteTransferConvite({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const contrato = new URLSearchParams(window.location.search).get('contrato');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const history = useHistory();
    const idioma = getIdiomaCodigo();

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //o back decide a etapa (proximoStep). Se esta tela ('transfer') não é a etapa atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'transfer') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            setDados(dadosRecebidos);
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const validar = () => {
        //OBS Transfer Extra obrigatória — apenas quando o campo está visível
        //(transfer extra habilitado e modelo diferente de chiesi, que oculta a textarea)
        const modelo = dados.evento?.cliente?.modelo ?? "master";
        if ((dados.transferextra ?? "nao") === 'sim' && !['chiesi'].includes(modelo)) {
            if ((dados.transferextraobservacao ?? '') === '') {
                toast.error(getText('requiredField') + ': ' + getText('transferExtra'));
                setTimeout(() => {
                    document.querySelector("#transferextraobservacao")?.focus();
                }, 500);
                return false;
            }
        }
        return true;
    };

    const salvar = () => {
        var idEvento = dados.evento.id;

        if (!validar()) {
            return false;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/participante/escolhaTransfer/' + id,
            token: token,
            data: {
                transferextra: (dados.transferextraobservacao ?? '') === '' ? 'nao' : 'sim',
                transferextraobservacao: dados.transferextraobservacao ?? null,
                transferobservacao: dados.transferobservacao ?? null,
            }
        })
            .then(function (response) {
                toast.success(getText('dadosSalvosSucesso'));
                //o back resolve a próxima etapa com o estado fresco pós-save (overlay de load durante o GET).
                irParaProximoStep(history, { id, token, eventoId: idEvento, contrato, setLoading: setIsLoading });
            })
            .catch(function () {
                toast.error(`${getText('error')} ${getText('errorSavingDefault')}`);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">{getText('transfer')}</h1></div>
                </div>

                {!isLoading && !isError && dados?.evento?.id && (
                    <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                        <div className="fin-pp__card" style={{ padding: 24, marginBottom: 16 }}>
                            {(dados.transferextra ?? "nao") === 'sim' && (
                                <div style={{ marginBottom: 20 }}>
                                    <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                        <h2 className="fin-pp__cphead-title">{getText('transferExtra')}</h2>
                                    </div>
                                    {/* participante → evento → texto padrão; || para que texto vazio também herde */}
                                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8, whiteSpace: 'pre-wrap' }}>
                                        <strong>{getText('transferExtra')} </strong>{dados.transferextradescricao || dados.evento?.transfer_extra_descricao || getText('transferExtraDescricao')}
                                    </p>
                                    <p style={{ color: 'var(--fin-tx)', marginBottom: 12 }}>{getText('dataHorarioTransfer')}</p>
                                    {!['chiesi'].includes((dados.evento?.cliente?.modelo ?? "master")) &&
                                        <>
                                            <p style={{ color: 'var(--fin-tx)', marginBottom: 12 }}>{getText('informarEndereco')}</p>
                                            <div className="fin-pp__filters">
                                                <FinField label={getText('enderecoPlaceholder')} full>
                                                    <FinTextarea
                                                        placeholder={getText('enderecoPlaceholder')}
                                                        value={dados.transferextraobservacao}
                                                        onChange={e => setDados({ ...dados, ...{ "transferextraobservacao": e.target.value } })}
                                                    />
                                                </FinField>
                                            </div>
                                        </>
                                    }
                                </div>
                            )}

                            {(dados.transfer ?? "nao") === 'sim' && (
                                <div style={{ marginBottom: 20 }}>
                                    <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                        <h2 className="fin-pp__cphead-title">{getText('transferDescricao')}</h2>
                                    </div>
                                    {/* mesma ordem do transfer extra; a chave transferDescricao é o rótulo "Transfer:", a rota padrão é a transferDescricaoCompleta */}
                                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8, whiteSpace: 'pre-wrap' }}>
                                        <strong>{getText('transferDescricao')} </strong>{dados.transferdescricao || dados.evento?.transfer_descricao || getText('transferDescricaoCompleta')}
                                    </p>
                                    {!['chiesi'].includes((dados.evento?.cliente?.modelo ?? "master")) &&
                                        <>
                                            <p style={{ color: 'var(--fin-tx)', marginBottom: 12 }}>{getText('naoUtilizarTransfer')}</p>
                                            <div className="fin-pp__filters">
                                                <FinField label={getText('observacaoPlaceholder')} full>
                                                    <FinTextarea
                                                        placeholder={getText('observacaoPlaceholder')}
                                                        value={dados.transferobservacao}
                                                        onChange={e => setDados({ ...dados, ...{ "transferobservacao": e.target.value } })}
                                                    />
                                                </FinField>
                                            </div>
                                        </>
                                    }
                                </div>
                            )}

                            <div className="fin-pp__cphead" style={{ marginBottom: 12 }}>
                                <h2 className="fin-pp__cphead-title">{getText('informacoesImportantesTransfer')}</h2>
                            </div>
                            <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>
                                {getText('servicoExclusivo')} {dados.tipoparticipante === 1 ? getText('medico') : getText('convidado')} {getText('patrocinado')}
                            </p>
                            <p style={{ color: 'var(--fin-tx)' }}>
                                {getText('alterarVoo')} {dados.tipoparticipante === 1 ? getText('medico') : getText('convidado')} {getText('patrocinado')}.<br />
                                {getText('alteracoesAtrasos')}
                            </p>
                        </div>

                        <div className="fin-pp__card" style={{ padding: 16 }}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <button
                                    type="submit"
                                    className="fin-pp__btn fin-pp__btn--primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />{getText('salvando')}</>
                                    ) : (
                                        <><FaSave size={16} style={{ marginRight: 6 }} />{getText('salvar')}</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </ErpTemplate>
    );
}
